import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Card, Col, Container, Row, Form, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  createSalary,
  resetSalaryCreate,
  getAllSalaries,
  getSalaryByEmployeeId,
} from '../features/salary/salarySlice'
import {
  getAllEmployees,
  resetEmployeeList,
  getEmployeeById,
  updateEmployeePaidStatus,
} from '../features/employee/employeeSlice'
import { toast } from 'react-toastify'
import Loader from '../components/Loader'
import { logout } from '../features/user/userSlice'

const SalaryEntry = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [employeeName, setEmployeeName] = useState('')
  // const [amount, setAmount] = useState("");
  // const [monthOfPayment, setMonthOfPayment] = useState("");

  const [allEmployees, setAllEmployees] = useState([])
  const [selectedEmployee, setSelectedEmployee] = useState([])
  const [salaries, setSalaries] = useState({})

  const [employee, setEmployee] = useState([])
  // const [paidEmployeeIds, setPaidEmployeeIds] = useState([]);

  const [paidEmployees, setPaidEmployees] = useState([]) // to track the already paid employees in a specific month

  //user selector
  const { userInfo } = useSelector((state) => state.user)

  const {
    salary,
    isCreateLoading,
    isCreateError,
    isCreateSuccess,
    createErrorMessage,

    isListLoading: isSalaryListLoading,
    isListError: isSalaryListError,
    isListSuccess: isSalaryListSuccess,
    listErrorMessage: listSalaryErrorMessage,
  } = useSelector((state) => state.salary)

  const {
    employees,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,
  } = useSelector((state) => state.employee)

  useEffect(() => {
    if (!userInfo) {
      toast.error('Please Login to Get Access!!', { position: 'top-center' })
      navigate('/login')
    }
    if (userInfo.permissions?.includes('salaryEntry') === false) {
      toast.error('Why Paknami Bro???', {
        position: 'top-center',
      })
      dispatch(logout())
    }
  }, [userInfo, navigate, dispatch])

  // Employee List
  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: 'top-center' })
    } else if (isListSuccess) {
      setAllEmployees(employees)
    } else {
      dispatch(getAllEmployees())
    }
  }, [dispatch, isListError, isListSuccess, listErrorMessage, employees])

  useEffect(() => {
    if (isCreateSuccess) {
      toast.success('Salary Created Successfully', {
        position: 'top-center',
      })
      navigate('/salaryExpense')
    } else if (isCreateError) {
      toast.error(createErrorMessage, {
        position: 'top-center',
      })
    }
  }, [isCreateSuccess, isCreateError, createErrorMessage, navigate, salary])

  // fetch paid employees of the current month by employee id
  useEffect(() => {
    const fetchPaidEmployees = async () => {
      try {
        const currentMonth = new Date().toLocaleString('en-US', {
          month: 'long',
        })
        const response = await axios.get('/api/v1/salaryPayment', {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        })

        console.log('API response : ', response)
        console.log('Data Field : ', response.data)

        const salaries = response.data.data || response.data

        console.log('Salaries dekhi : ', salaries)

        // const paidEmployeeIds = paidEmployees.map((emp) => emp._id);
        // console.log("IDS : ", paidEmployeeIds);

        if (Array.isArray(salaries)) {
          const paid = salaries.filter(
            (salary) =>
              salary.monthOfPayment?.toLowerCase() ===
              currentMonth.toLowerCase()
          )

          // console.log("Filter korar por paidSalaries : ", paid);

          // const paidEmployeesIds = paid.map((salary) =>
          //   // console.log("Bhai Employee Id pls : ", salary.employeeId);
          //   salary.employeeId
          // );

          // console.log("Paid employees ID: ", paidEmployeesIds);
          // const paidEmployeesNames = paid.map((salary) => salary.employeeName);
          // setPaidEmployees(paidEmployeesNames);

          // setPaidEmployees(paid.map((salary) => salary.employeeId));
          // setPaidEmployees(paidEmployeesIds);
          setPaidEmployees(paid.map((salary) => salary.employeeId))

          // dispatch(updateEmployeePaidStatus(paidEmployeesIds))

          // Update employee list with isPaid status
          // setEmployee((prevEmployees) =>
          //   prevEmployees.map((employee) => ({
          //     ...employee,
          //     isPaid: paidEmployeesIds.includes(employee._id),
          //   }))
          // );
        } else {
          throw new Error('Unexpected API response format')
        }
      } catch (error) {
        toast.error('Failed to fetch paid employees!', {
          position: 'top-center',
        })
      }
    }

    // Fetch paid employees when the component mounts/component loads
    fetchPaidEmployees()

    // Check the current month and fetch data
    const checkMonth = () => {
      const currentMonth = new Date().getMonth() // Current month
      const storedMonth = localStorage.getItem('currentMonth')

      if (storedMonth === null || parseInt(storedMonth) !== currentMonth) {
        localStorage.setItem('currentMonth', currentMonth) // Update stored month
        setPaidEmployees([]) // Reset paid employees
        fetchPaidEmployees() // Fetch new data
      }
    }
    checkMonth()

    const interval = setInterval(checkMonth, 24 * 60 * 60 * 1000) // Check daily

    return () => clearInterval(interval) // Cleanup interval on unmount
  }, [userInfo.token, dispatch])

  // console.log("all employees : ", allEmployees);
  // console.log("paid employees : ", paidEmployees);

  // console.log("IDS : ", paidEmployeeIds);
  // console.log("employee:", employee);
  // console.log("Employees data:", employees); // Log the array being mapped
  // console.log("employee._id:", employee?._id);
  // {
  //   allEmployees.map(employee => {
  //     console.log("employee._id:", employee?._id);
  //   })
  // }

  useEffect(() => {
    return () => {
      dispatch(resetSalaryCreate())
    }
  }, [dispatch])

  const submitHandler = (e) => {
    e.preventDefault()

    if (selectedEmployee.length === 0) {
      toast.error('Please Select Employees to Allocate Salary!', {
        position: 'top-center',
      })
      return
    }

    // Send names of selected employees
    const payloads = selectedEmployee
      .map((employeeId) => allEmployees.find((emp) => emp._id === employeeId))
      .filter((employee) => employee) // Remove invalid employees
      .map((employee) => ({ employeeName: employee.fullName }))

    // Dispatch each salary creation request
    payloads.forEach((payload) => {
      dispatch(createSalary(payload))
    })

    toast.success('Salary Creation Initiated!', {
      position: 'top-center',
    })
  }

  const handleEmployeeSelect = (e) => {
    const employeeId = e.target.value
    const isSelected = e.target.checked

    if (isSelected) {
      setSelectedEmployee([...selectedEmployee, employeeId])

      // const employee = allEmployees.find((emp) => emp._id === employeeId);
      // setPaidEmployees(
      //   paidEmployees.includes(employee.fullName)
      //     ? paidEmployees.filter((name) => name !== employee.fullName)
      //     : [...paidEmployees, employee.fullName]
      // );
    } else {
      setSelectedEmployee(selectedEmployee.filter((id) => id !== employeeId))
    }
  }

  useEffect(() => {
    if (selectedEmployee.length > 0) {
      const fetchSalaries = async () => {
        const salariesData = await Promise.all(
          selectedEmployee.map((employeeId) =>
            dispatch(getSalaryByEmployeeId(employeeId))
          )
        )
        setSalaries(
          salariesData.reduce((acc, { payload }, index) => {
            acc[selectedEmployee[index]] = payload
            return acc
          }, {})
        )
      }
      fetchSalaries()
    }
  }, [selectedEmployee, dispatch])

  const handleGetSalary = () => {
    if (selectedEmployee.length > 0) {
      selectedEmployee.map((employeeId) => {
        dispatch(getSalaryByEmployeeId(employeeId))
      })
    }
  }

  useEffect(() => {
    if (isSalaryListError) {
      toast.error(listSalaryErrorMessage, { position: 'top-center' })
    } else if (isSalaryListSuccess) {
      // setSalaries(salaries);
    } else {
      handleGetSalary()
    }
  }, [isSalaryListError, isSalaryListSuccess, listSalaryErrorMessage])

  useEffect(() => {
    const fetchSalaries = async () => {
      const salariesData = await Promise.all(
        selectedEmployee.map((employeeId) => {
          // get employee salary by id
          return getSalaryByEmployeeId(employeeId)
        })
      )

      setSalaries(
        salariesData.reduce((acc, salary, index) => {
          acc[selectedEmployee[index]] = salary
          return acc
        }, {})
      )
    }

    fetchSalaries()
  }, [selectedEmployee])

  useEffect(() => {
    return () => {
      dispatch(resetEmployeeList())
    }
  }, [dispatch])

  return (
    <Container fluid className='my-4'>
      {/* <h2 style={{ fontWeight: "bold" }} className="mb-5 text-center">
        Salary Entry
      </h2> */}
      <Row className='mb-4'>
        <Card
          className='rounded-4 border'
          style={{ backgroundColor: '#e6edf1' }}
        >
          <h2 className='my-3 text-dark text-center fw-bold'>
            <span style={{ color: '#5c91dc' }}>Salary</span> Entry
          </h2>
        </Card>
      </Row>

      <>
        {isCreateLoading ? (
          <Loader />
        ) : (
          <Form onSubmit={submitHandler}>
            <Row>
              <Col sm={12} md={12} lg={12}>
                {/* All the employees will be mapped here with a check box beside the name */}
                <Card className='shadow rounded'>
                  <Card.Header
                    as='h5'
                    className='p-3 text-center fw-bold text-black'
                    style={{ backgroundColor: '#74a2e3' }}
                  >
                    Salary Entry
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      {/* Show All Employees */}
                      <Col
                        sm={12}
                        md={6}
                        lg={6}
                        className='d-flex justify-content-center'
                      >
                        <Form.Group controlId='employeeName'>
                          <Form.Label style={{ color: 'black' }}>
                            Employees List
                          </Form.Label>
                          {/* <Form.Check type="checkbox"> */}
                          {allEmployees.length === 0 ? (
                            <p>No Employees Found</p>
                          ) : (
                            allEmployees &&
                            allEmployees.map((employee) => {
                              // console.log("Employee Id : ", employee._id);
                              // console.log("Paid Employees : ", paidEmployees);
                              // console.log(
                              //   "Paid Employee Ids : ",
                              //   paidEmployeeIds
                              // ),

                              const paidEmployeeIds = paidEmployees.map(
                                (emp) => emp._id
                              )

                              console.log(
                                'Paid Employee Ids : ',
                                paidEmployeeIds
                              )
                              return (
                                <Form.Check
                                  key={employee._id}
                                  type='checkbox'
                                  label={employee.fullName}
                                  value={employee._id}
                                  onChange={(e) => handleEmployeeSelect(e)}
                                  disabled={
                                    employee._id &&
                                    paidEmployeeIds?.includes(employee?._id)
                                  }
                                />
                              )
                            })
                          )}
                          {/* </Form.Check> */}
                        </Form.Group>
                      </Col>

                      {/* Show Selected Employee Salary */}
                      <Col sm={12} md={6} lg={6}>
                        {/* Selected Employees Salary will be shown here */}
                        <Form.Group controlId='salary'>
                          <Form.Label style={{ color: 'black' }}>
                            Salary
                          </Form.Label>

                          <Row>
                            {allEmployees &&
                              selectedEmployee.map((employeeId) => {
                                const employee = allEmployees.find(
                                  (emp) => emp._id === employeeId
                                )

                                return (
                                  <Form.Label key={employeeId}>
                                    {employee?.salary || 'Not Found'}
                                  </Form.Label>
                                )
                              })}
                          </Row>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>

                  <Row className='mx-3 mb-4'>
                    <Button
                      variant='outline-primary'
                      type='submit'
                      className='rounded'
                    >
                      Create Invoice
                    </Button>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </>
    </Container>
  )
}

export default SalaryEntry
